import { FieldSet, FormHelp, Heading, Label, LabeledControl, Radio } from '@zillow/constellation';
import { Controller, useFormContext } from 'react-hook-form';
import { isValidNonNull } from '../../../../utils/validation';

export function SmokingStep() {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name="isSmoker"
      rules={{ validate: isValidNonNull }}
      render={({ field: { onChange, value, onBlur } }) => (
        <FieldSet
          legend={
            <Heading level={4} as="Legend" marginBottom="sm" fontFamily="serif">
              Does anyone in the household smoke?
            </Heading>
          }
          description={errors.isSmoker && <FormHelp>{errors.isSmoker.message}</FormHelp>}
          error={!!errors.isSmoker}
          onBlur={onBlur}
        >
          <LabeledControl
            onChange={() => onChange(true)}
            label={<Label>Yes</Label>}
            control={<Radio name="isSmoker" defaultChecked={value === true} />}
          />
          <LabeledControl
            onChange={() => onChange(false)}
            label={<Label>No</Label>}
            control={<Radio name="isSmoker" defaultChecked={value === false} />}
          />
        </FieldSet>
      )}
    />
  );
}
